import React from "react";
import Seo from "../../../shared/ui/Seo";
import Image1 from "../../../assets/images/aboutus/image1.jpeg";
import Image2 from "../../../assets/images/aboutus/image2.jpeg";
const AboutUs = () => {

  return (
    <div className="container container-lg py-24">
      <Seo
        title="About Us"
        description="Learn about Bigmall, Sri Lanka's online shopping mall bringing quality products, great prices and reliable island-wide delivery to your doorstep."
      />
      <h1 className="page-title">About Us</h1>

      {/* Our Story */}
      <section className="mb-5">
        <div className="d-flex align-items-start mb-3">
          <span className="badge  bg-primary me-3 fs-5">01</span>
          <h6 className="fw-bold m-0">Our Story</h6>
        </div>
        <p>
          Bigmall's journey began with a vision to revolutionize the e-commerce
          landscape, connecting individuals, entrepreneurs, and businesses from
          all corners of the globe. Inspired by the potential of e-commerce to
          bridge geographical boundaries and empower diverse communities, we
          embarked on a mission to create a platform that transcends traditional
          commerce.
        </p>
        <p>
          In the vast tapestry of global markets, we envisioned a seamless
          fusion of technology and commerce, where every aspiring seller could
          showcase their unique offerings and every discerning buyer could
          explore an extensive array of products. Our founders, driven by a
          passion for innovation and a desire to foster entrepreneurship, set
          out to build a platform that would democratize access to markets and
          amplify the voices of countless sellers.
        </p>
      </section>

      {/* Our Promise */}
      <section>
        <div className="d-flex align-items-start mb-3">
          <span className="badge bg-success me-3 fs-5">02</span>
          <h6 className="fw-bold m-0">Our Promise</h6>
        </div>
        <p>
          At Bigmall, we wholeheartedly pledge to put our customers first in all
          our endeavors. Our commitment begins with a customer-centric approach,
          ensuring that every shopping experience is not only seamless but also
          tailored to meet individual needs and preferences.
        </p>
        <p>
          We stand unwavering in our dedication to delivering products and
          services of the highest quality, meticulously selected to surpass
          expectations. Transparency and reliability are the cornerstones of our
          interactions; we promise clear communication and trustworthiness in
          every transaction.
        </p>
        <p>
          Sustainability and social responsibility are deeply ingrained in our
          ethos, propelling us to minimize our environmental impact and give
          back to the communities we serve. At Bigmall, we are continuously
          driven by innovation, constantly evolving to bring you the latest
          trends and technologies to enhance your shopping journey.
        </p>
      </section>
      <section className="d-flex justify-content-center align-items-center gap-20 flex-wrap mt-5">
        <img
          src={Image1}
          alt="About Us"
          className="img-fluid"
          style={{ width: "300px", height: "200px", objectFit: "cover" }}
        />
        <img
          src={Image2}
          alt="About Us"
          className="img-fluid"
          style={{ width: "300px", height: "200px", objectFit: "cover" }}
        />
      </section>
    </div>
  );
};

export default AboutUs;
